// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_MJbLW","secondaryColumnCell":"secondary-column-cell_MJbLW","name":"name_lgT40","label":"label_478S4"};